module.exports = __webpack_public_path__ + "media/img/use-ico-8-af9d34f41f2f85b1ed21bfb915a5a40f.svg";